import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Condition } from '../../../../../models/condition.model';
import { Component as ComponentModel } from '../../../../../models/component.model';
import { ComponentType } from '../../../../../shared/enums/component-type/component-type.module';
import { InputType } from '../../../../../shared/enums/input-type/input-type.module';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { OptionsType } from '../../../../../shared/enums/options-type/options-type.module';
import { RefBusinessLists } from '../../../../../models/refBusinessLists.model';
import { SelectOption } from '../../../../../models/selectOption.model';
import { OperatorType } from '../../../../../shared/enums/operator-type/operator-type.module';
import { UtilsService } from '../../../../../services/shared/utils/utils.service';

@Component({
  selector: 'app-condition',
  templateUrl: './condition.component.html',
  styleUrl: './condition.component.css'
})
export class ConditionComponent implements OnInit {
  @Input() condition!: Condition;
  @Input() sourceComponent: ComponentModel | undefined;
  @Input() refBusinessLists!: RefBusinessLists;
  @Output() positionChanged = new EventEmitter<string>();
  @Output() removeCondition = new EventEmitter<void>();

  ComponentType = ComponentType;
  InputType = InputType;
  separatorKeysCodes: number[] = [ENTER, COMMA];

  newConditionValue: string = '';
  newConditionAction: string = 'display';
  newConditionPosition: string = 'apart';
  newConditionOperatorType: OperatorType = OperatorType.EQUAL;

  booleanOptions: Record<string, string> = {
    "0": "false",
    "1": "true"
  };

  optionsEntries: SelectOption[] = [];

  operatorTypes = [
    { label: '==', value: OperatorType.EQUAL },
    { label: '!=', value: OperatorType.NOT_EQUAL },
    { label: '>', value: OperatorType.GREATER_THAN },
    { label: '<', value: OperatorType.LESSER_THAN },
    { label: '(.*)', value: OperatorType.REGEX }
  ];

  constructor(
    public utils: UtilsService
  ) { }

  ngOnInit(){
    if(this.sourceComponent?.config?.inputType == InputType.COLOR_PICKER || this.sourceComponent?.config?.inputType == InputType.FILE || this.sourceComponent?.config?.inputType == InputType.DATE){
      this.newConditionValue = '*';
    }
    else if(this.sourceComponent?.type === ComponentType.SELECT && this.sourceComponent?.config?.options)
    {
      if(this.sourceComponent.config.optionsType == OptionsType.ACTIVITIES)
      {
        this.optionsEntries = this.refBusinessLists.activities ? this.refBusinessLists.activities.map(x => ({
          display: x.labelBusiness,
          value: x.code
        })) : [];
      }
      else if(this.sourceComponent.config.optionsType == OptionsType.CERTIFICATIONS)
      {
        this.optionsEntries = this.refBusinessLists.certifications ? this.refBusinessLists.certifications.map(x => ({
          display: x.labelBusiness,
          value: x.code
        })) : [];
      }
      else{
        this.optionsEntries = this.sourceComponent?.config?.options;
      }

      if (this.optionsEntries.length > 0) {
        this.newConditionValue = this.optionsEntries[0].value;
      }
    }
    else if(this.sourceComponent?.type === ComponentType.CHECKBOX)
    {
      this.newConditionValue = "1";
    }

    if(this.condition.rules.length === 0)
    {
      this.onAddRule();
    }
    else{
      this.condition.rules.filter(r => !r.operatorType).forEach(r => {
        r.operatorType = OperatorType.EQUAL;
      })
    }
  }

  onAddRule(){
      this.condition.rules.push({
        value: this.newConditionValue.toString(),
        action: this.newConditionAction,
        operatorType: this.newConditionOperatorType
      });
  }

  onRemoveRule(ruleIndex: number){
    this.condition.rules.splice(ruleIndex,1)
  }

  onRemoveCondition() {
    this.removeCondition.emit();
  }

  stripHtml(html: string){
    return this.utils.stripHtml(html);
  }

  isHtml(value: string){
    return this.utils.containsHtml(value);
  }
}
